import cloneDeep from 'lodash/cloneDeep';
import findIndex from 'lodash/findIndex';

const formate = (arr, originalList, val) => {
  arr.forEach(ele => {
    ele.checked = val;
    if (originalList.length > 0) {
      const originalKey = findIndex(originalList, {id: ele.id});
      originalList[originalKey].checked = val;
    }
  });
};

export const confirmCheckedAll = (originArr) => findIndex(originArr, {checked: false}) === -1;

export const checked = (id, state) => {
  const shipments = cloneDeep(state.results.shipments);
  const key = findIndex(shipments, {id});
  shipments[key].checked = !shipments[key].checked;
  const originalList = cloneDeep(state.originalList) || [];
  if (originalList.length > 0) {
    const originalKey = findIndex(originalList, {id});
    originalList[originalKey].checked = shipments[key].checked;
  }
  const checkedAll = confirmCheckedAll(shipments);
  return {
    originalList,
    results: {
      ...state.results,
      shipments,
    },
    checkedAll,
  };
};

export const checkedAll = (state) => {
  const shipments = cloneDeep(state.results.shipments);
  const originalList = cloneDeep(state.originalList) || [];
  let checkedAll = !state.checkedAll;
  formate(shipments, originalList, checkedAll);
  return {
    results: {
      ...state.results,
      shipments,
    },
    originalList,
    checkedAll,
  };
};

// 筛选出已选中的loads
export const filterChecked = (originArr) => {
  const checked = [];
  originArr.forEach(ele => {
    if (ele.checked) {
      checked.push(ele.id);
    }
  });
  return checked;
};

export const statistyChecked = (arr) => {
  const array = [];
  arr.forEach(ele => {
    if (ele.checked) {
      array.push(ele.id);
    }
  });
  return array;
};



// WEBPACK FOOTER //
// ./src/misc/checked.js